import { graphql } from '@/generated/gql';

export const AWARDING_CONFIGURATION_WIDGET_QUERY = graphql(/* GraphQL */ `
  query AwardingConfiguration($id: UUID!) {
    tesseract {
      demand(id: $id) {
        id
        awardingConfiguration {
          id
          deadline
          deadlineDays
          performAutomaticAwarding
          rules {
            id
            priceDeviation
            variant
          }
        }
      }
    }
  }
`);
